var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M2 21H14V21C14 18.7909 12.2091 17 10 17H6C3.79086 17 2 18.7909 2 21V21Z",
    fill: "#0973F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04249 15L5.75637 12.8803H10.2096L10.9235 15H14L9.68272 3H6.31728L2 15H5.04249ZM7.983 6.23077L9.46176 10.6239H6.52125L7.983 6.23077Z",
    fill: "#00AEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M13 21L3 21",
    stroke: "#00AEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5536 10.4103C20.9893 10.4967 21.3393 10.6978 21.6036 11.0135C21.8678 11.3293 22 11.69 22 12.0954C22 12.6804 21.7804 13.1441 21.3411 13.4865C20.9018 13.8288 20.2893 14 19.5036 14H16V7H19.3857C20.15 7 20.7482 7.16286 21.1804 7.4886C21.6125 7.81434 21.8286 8.25641 21.8286 8.81482C21.8286 9.22697 21.7125 9.56932 21.4804 9.84188C21.2482 10.1145 20.9393 10.3039 20.5536 10.4103ZM17.8321 9.83191H19.0321C19.3321 9.83191 19.5625 9.77044 19.7232 9.64744C19.8839 9.52445 19.9643 9.34331 19.9643 9.10399C19.9643 8.86467 19.8839 8.68186 19.7232 8.55556C19.5625 8.42925 19.3321 8.3661 19.0321 8.3661H17.8321V9.83191ZM19.8946 12.4295C19.7268 12.5591 19.4893 12.6239 19.1821 12.6239H17.8321V11.0783H19.1607C19.4678 11.0783 19.7089 11.1481 19.8839 11.2877C20.059 11.4274 20.1464 11.6202 20.1464 11.8661C20.1464 12.112 20.0625 12.2999 19.8946 12.4295Z",
    fill: "#0973F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabs);
export default __webpack_public_path__ + "static/media/tabs.5abe1d31.svg";
export { ForwardRef as ReactComponent };